module.exports = __webpack_public_path__ + "img/logo.cafb0cb3.jpg";